import { RoundsRepo } from "@/repos/RoundsRepo";
import { Timestamp } from "firebase/firestore";
import { UserDashboardService } from "./UserDashboardService";
import { resolveType } from "./ServiceContainer";
import { RoundModel } from "@/models/RoundModels";
import { CourseModel } from "@/models/CourseModels";

// src/services/RoundService.ts
export class RoundService {
    constructor(private roundsRepo: RoundsRepo, private userDashboardService: UserDashboardService) { }

    async get(id: string): Promise<RoundModel | null> {
        return await this.roundsRepo.getById(id);
    }

    /** Creates a new round and updates the user dashboard, writing everything to the server and local cache. */
    async create(round: RoundModel, userId: string, courseModel: CourseModel | null): Promise<string> {
        if (!round.id) {
            round.id = await this.roundsRepo.createFirestoreId();
        }
        await this.roundsRepo.create(round, round.id);
        await this.userDashboardService.updateForRound(round, userId, courseModel);
        return round.id;
    }

    async update(id: string, userId: string | null, updates: Partial<RoundModel>, courseModel: CourseModel | null): Promise<void> {
        updates.updatedAt = Timestamp.now();
        await this.roundsRepo.update(id, updates);
        const round = await this.get(id);
        await this.userDashboardService.updateForRound(round!, userId || round!.users[0].uid, courseModel);
    }

    // async updateLocal(id: string, userId: string, updates: Partial<RoundModel>): Promise<void> {
    //     updates.updatedAt = Timestamp.now();
    //     await this.roundsRepo.update(id, updates);
    //     const round = await this.get(id);
    //     await this.userDashboardService.updateForRound(round!, userId);
    // }

    async complete(roundModel: RoundModel, userId: string, courseModel: CourseModel | null): Promise<void> {

        roundModel.status = 'completed';
        roundModel.completedAt = Timestamp.now();

        // make absolutely sure whatever the model they gave us is the model we have in the cache and the one we write to the server
        await this.update(roundModel.id, userId, roundModel, courseModel);

        // update their dashboard accordingly
        const userDashboardService = resolveType(UserDashboardService);
        await userDashboardService.updateForRound(roundModel!, userId || roundModel!.users[0].uid, courseModel);

        // LeagueResultModel is now saved at admin week locking time

    }


    async delete(id: string, userId: string): Promise<void> {
        await this.userDashboardService.removeRound(userId, id);
        await this.roundsRepo.delete(id);
    }

    async findByLeagueDayAndUser(leagueId: string, dayId: string, userId: string): Promise<RoundModel[]> {
        return await this.roundsRepo.findByQuery([
            ['setup.league.id', '==', leagueId],
            ['setup.league.dayId', '==', dayId],
            [`users.${userId}`, '!=', null]
        ]);
    }
}